import axios, { AxiosInstance } from 'axios';

/* eslint-disable */
class Axios {
    axiosBase: AxiosInstance;

    constructor() {
        const { hostname } = window.location,
            isProd = hostname === 'odn.titans.town',
            isLocal = hostname === 'localhost';

        this.axiosBase = axios.create({
            baseURL: isProd ? 'https://www.onedome.com' : isLocal
                    ? ''
                    : 'https://web-d0a8ba30.qa.onedome.com',
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {}
        });
    }

    get(url: string, config?: any) {
        return this.axiosBase.get(url, config);
    }

    // if data is absent - then content type is not bypassed for some reason
    put(url: string, data: any = {}, config?: any) {
        return this.axiosBase.put(url, data, config);
    }

    delete(url: string, data?: any) {
        return data
            ? this.axiosBase.delete(url, {
                data: data
            })
            : this.axiosBase.delete(url);
    }

    post(url: string, data: unknown, config?: any) {
        return this.axiosBase.post(url, data, config);
    }

    postFormData(url: string, data: unknown) {
        return (axios as any)({
            method: 'post',
            url: url,
            data: data,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        });
    }

    postFiles(url: string, data: unknown) {
        return axios.post(url, data);
    }
}

export default new Axios();
/* eslint-enable */
